var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpark51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3763 7.04818C18.2171 5.88768 18.116 4.25339 17.0729 3.21001C15.9447 2.08145 14.1352 2.04951 12.9697 3.11951V2.97046C12.9697 1.33085 11.6392 0 10 0C8.36083 0 7.03034 1.33085 7.03034 2.97046V3.11951C5.86482 2.05483 4.05535 2.08145 2.92709 3.21001C1.87866 4.25872 1.77754 5.88768 2.62374 7.04818C1.14955 7.21853 0 8.47485 0 9.99734C0 11.6369 1.3305 12.9678 2.96967 12.9678H3.11868L2.93241 13.1541C1.77222 14.3146 1.77222 16.1938 2.93241 17.3543C4.06599 18.4882 5.89675 18.5148 7.05695 17.4182C7.24854 18.8714 8.49388 20 10 20C11.5061 20 12.7515 18.8768 12.9431 17.4182C14.1086 18.5094 15.934 18.4882 17.0676 17.3543C18.2278 16.1938 18.2278 14.3146 17.0676 13.1541L16.8813 12.9678H17.0303C18.6695 12.9678 20 11.6369 20 9.99734C19.9947 8.47485 18.8505 7.21853 17.3763 7.04818Z",
    fill: "#232323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark51);
export default __webpack_public_path__ + "static/media/spark-51.6a83f8478a4e1b1dd6c99a9da3d81a9f.svg";
export { ForwardRef as ReactComponent };